module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('vue-dropzone', {
    ref: "fileUpload",
    attrs: {
      "id": "dropzone",
      "options": _vm.dropzoneOptions
    },
    on: {
      "vdropzone-success": _vm.success,
      "vdropzone-complete": _vm.onComplete,
      "vdropzone-removed-file": _vm.removedFile,
      "vdropzone-max-files-exceeded": function($event) {
        _vm.setError("maxFiles")
      }
    }
  }), (_vm.rules && _vm.rules.length) ? _c('markdown', {
    staticClass: "rules",
    attrs: {
      "source": _vm.rules
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c694bee8"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/gotu-vue-common/src/components/file-upload/FileUpload.vue
// module id = 2089
// module chunks = 1